import React from "react";
import classNames from "classnames";
import { UIPropsWithoutRef } from "@spectrumselect/mi-ui-react";
import Tick from "../../images/Counter.svg";
import "./SuccessMessage.scss";

export const SuccessMessage: React.FunctionComponent<UIPropsWithoutRef<"p">> = (props) => {
  return (
    <p
      {...props}
      className={classNames("successMessage", "App_formError", props.className)}
      role="alert">
      <div className="row">
      <div className="col-md-1">
        <img src={Tick} alt="ok" />
      </div>
      <div className="col-md-11 text">
        <h4>Password changed</h4>
        <p>{props.children}</p>
      </div>
      </div>
    </p>
  );
}
